const CONSENT_KEY = 'genmoney-analytics-consent';
// Invalidate pre-activation choices: the Google Analytics notice is now active.
const POLICY_VERSION = 'pre-activation-2';
const MAX_AGE = 180 * 24 * 60 * 60 * 1000;
const CHANGE_EVENT = 'genmoney-analytics-consent-change';
let storageFailed = false;

const readRecord = () => {
  if (storageFailed) return null;
  try {
    const saved = JSON.parse(window.localStorage.getItem(CONSENT_KEY));
    const age = Date.now() - saved?.updatedAt;
    if (saved?.version !== POLICY_VERSION || !Number.isFinite(saved?.updatedAt) || age < 0 || age >= MAX_AGE || !Number.isFinite(age)) return null;
    return ['granted', 'denied'].includes(saved.choice) ? saved : null;
  } catch {
    return null;
  }
};

export const readAnalyticsConsent = () => readRecord()?.choice ?? null;
export const hasConsentStorageFailure = () => storageFailed;

export const saveAnalyticsConsent = (choice) => {
  if (!['granted', 'denied'].includes(choice)) return false;
  try {
    window.localStorage.setItem(CONSENT_KEY, JSON.stringify({
      choice, version: POLICY_VERSION, updatedAt: Date.now(),
    }));
    storageFailed = false;
    window.dispatchEvent(new Event(CHANGE_EVENT));
    return true;
  } catch {
    // Fail closed in this tab, even if a stale saved grant is still readable.
    storageFailed = true;
    try { window.localStorage.removeItem(CONSENT_KEY); } catch { /* Storage may be blocked. */ }
    window.dispatchEvent(new Event(CHANGE_EVENT));
    return false;
  }
};

export const subscribeAnalyticsConsent = (listener) => {
  let timer;
  const refresh = () => {
    window.clearTimeout(timer);
    listener();
    const saved = readRecord();
    if (saved) {
      const remaining = saved.updatedAt + MAX_AGE - Date.now();
      // Browser timers are capped at ~24 days; re-arm rather than overflowing.
      timer = window.setTimeout(refresh, Math.min(Math.max(remaining, 1), 2147483647));
    }
  };
  const storage = (event) => {
    if (event.key === CONSENT_KEY || event.key === null) refresh();
  };
  window.addEventListener('storage', storage);
  window.addEventListener(CHANGE_EVENT, refresh);
  window.addEventListener('focus', refresh);
  window.addEventListener('pageshow', refresh);
  document.addEventListener('visibilitychange', refresh);
  refresh();
  return () => {
    window.clearTimeout(timer);
    window.removeEventListener('storage', storage);
    window.removeEventListener(CHANGE_EVENT, refresh);
    window.removeEventListener('focus', refresh);
    window.removeEventListener('pageshow', refresh);
    document.removeEventListener('visibilitychange', refresh);
  };
};

export const consentStorageKey = CONSENT_KEY;